import { ChangeEvent, FC, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import styled from 'styled-components';
import { Button, TextArea } from '@uhg-harmony/uitk-react';
import { ButtonWrapper } from 'builder/scenes/SiteBuilder/PagesPanel/PagesPanel';

const StyledDialogTitle = styled(DialogTitle)`
  & .MuiTypography-h6 {
    font-family: 'OptumSans';
    color: ${p => p.theme.colors.aux.black};
    font-size: 18px;
    font-weight: 700;
  }
`;

const StyledDialogContent = styled(DialogContent)`
  & .MuiTypography-body1 {
    font-family: 'OptumSans';
    color: ${p => p.theme.colors.aux.black};
    font-size: 14px;
    font-weight: 500;
  }
`;

const StyledDialog = styled(Dialog)`
  width: 500px;
  margin-left: auto;
`;

const StyledDiv = styled.div`
  padding: 10px;
`;

const TextBoxStyles = {
  width: '385px',
  height: '135px',
  color: '#000000',
  'margin-left': '23px',
  'font-family': 'OptumSans',
  'margin-top': 'inherit',
};

export interface PublishNoteDialogProps {
  open?: boolean;
  onClose?: () => void;
  publishSite?: (siteId: number, publishMessage: string) => void;
  siteId: number;
}

const PublishNoteDialog: FC<PublishNoteDialogProps> = (
  props: PublishNoteDialogProps
) => {
  const [publishMessage, setPublishMessage] = useState('');

  const handlePublishMessage = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setPublishMessage(e.target.value);
  };

  const publishClick = () => {
    props.publishSite(props.siteId, publishMessage);
    setPublishMessage('');
  };

  const cancelClick = () => {
    props.onClose();
  };

  const { open, onClose } = props;
  return (
    <StyledDiv>
      <StyledDialog open={open} onClose={onClose}>
        <StyledDialogTitle>{'Publish With Note'}</StyledDialogTitle>
        <StyledDialogContent>
          <div>
            {
              <Typography variant="body1">
                {
                  'By adding notes to your publishes, you can see what changes were made when you look at your version history and help make it easier if you ever need to roll back a version.'
                }
              </Typography>
            }
          </div>
        </StyledDialogContent>
        <TextArea
          style={TextBoxStyles}
          value={publishMessage}
          onChange={handlePublishMessage}
          data-test-id="publish-message-textbox"
        />
        <ButtonWrapper>
          <Button onPress={publishClick} data-test-id="next-button">
            Publish
          </Button>
          <Button
            onClick={cancelClick}
            block
            className={'mt-base'}
            data-test-id="cancel-button"
          >
            Cancel
          </Button>
        </ButtonWrapper>
      </StyledDialog>
    </StyledDiv>
  );
};
export default PublishNoteDialog;
